import { render, staticRenderFns } from "./docx.vue?vue&type=template&id=123b67e4&scoped=true"
import script from "./docx.vue?vue&type=script&lang=js"
export * from "./docx.vue?vue&type=script&lang=js"
import style0 from "./docx.vue?vue&type=style&index=0&id=123b67e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123b67e4",
  null
  
)

export default component.exports